import { render, staticRenderFns } from "./DynamicTable.vue?vue&type=template&id=377d3a96&scoped=true"
import script from "./DynamicTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./DynamicTable.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DynamicTable.vue?vue&type=style&index=0&id=377d3a96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377d3a96",
  null
  
)

export default component.exports